// Area Navigation component

// This file was once generated when you created this area
// but you can edit it freely

import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { HeadsetIcon } from '@moia-dev/pace-icons'
import { RiderSupportAreaRoutes } from './RiderSupportAreaRoutes'

export const RiderSupportAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={RiderSupportAreaRoutes.route}
      Icon={HeadsetIcon}
    />
  )
}
